import { type AnaliticaPluginInterface } from '@stone-payments/analitica'
import { analiticaInstance } from 'shared/analitica'

import { type RavFlow, type RavStatus, generalSettings } from './rav-taxonomy'

export type RavErrorParams = {
  flow: RavFlow
  screen: string
  status: RavStatus
  description: string
  httpCode?: number
  errorCode?: string
  error?: unknown
  context?: Record<string, unknown>
}

export type RavSuccessParams = {
  flow: RavFlow
  screen: string
  status: RavStatus
  description: string
  context?: Record<string, unknown>
}

const toRavError = (error: unknown, fallbackMessage: string): Error => {
  if (error instanceof Error) {
    if (error.message) return error

    const fallback = new Error(fallbackMessage)
    fallback.name = error.name
    fallback.stack = error.stack
    return fallback
  }

  const fallback = new Error(fallbackMessage)
  fallback.name = 'RavError'
  return fallback
}

const datadogOnly = (plugins: AnaliticaPluginInterface[]) => plugins.filter(({ name }) => name !== 'AMPLITUDE')

const { events } = analiticaInstance.eventFactory('RavLogs', {
  logging: {
    onError: (params: RavErrorParams) => {
      const error = toRavError(params.error, params.description)

      return {
        label: 'rav-flow-error',
        filterPlugins: datadogOnly,
        metadata: {
          ...generalSettings,
          flow: params.flow,
          screen: params.screen,
          status: params.status,
          description: params.description,
          httpCode: params.httpCode,
          errorCode: params.errorCode,
          error,
          errorInfo: { name: error.name, message: error.message },
          context: params.context
        }
      }
    },

    onSuccess: (params: RavSuccessParams) => ({
      label: 'rav-flow-success',
      filterPlugins: datadogOnly,
      metadata: {
        ...generalSettings,
        flow: params.flow,
        screen: params.screen,
        status: params.status,
        description: params.description,
        context: params.context
      }
    })
  }
})

export const RavLogger = {
  error: events.logging.onError,
  success: events.logging.onSuccess
}
